
interface SidebarLayoutProps {
  children: React.ReactNode;
  sidebar: React.ReactNode;
}

export function SidebarLayout({ children, sidebar }: SidebarLayoutProps) {
  return (
    <div className="flex h-[calc(100vh-3.5rem)] bg-background">
      {/* Sidebar */}
      <div className="w-64 border-r">
        <div className="h-full py-6 px-4">
          {sidebar}
        </div>
      </div>
      
      {/* Main content */}
      <div className="flex-1 overflow-auto">
        <div className="h-full p-8">
          {children}
        </div>
      </div>
    </div>
  );
}